import {useState, useEffect} from 'react'
import { FaMobileAlt, FaFacebook, FaYoutube, FaTwitter, FaBars, FaEnvelope, FaGithub } from "react-icons/fa";
import { NavLink, useLocation } from 'react-router-dom';
import "./Header.css"
import OpenNewTab from '../../hooks/OpenNewTab';
import {Container, Row, Col} from 'react-bootstrap';

const Header = () => {
  const [navigationMenu, setNavigationMenu] = useState('navigation-menu');
  const location = useLocation();
  const {openInNewTab} = OpenNewTab();

  const handleToggleButton = (e) =>{
    e.preventDefault();
    if (navigationMenu === "navigation-menu") {
        setNavigationMenu("navigation-menu responsive")
    } else {
        setNavigationMenu("navigation-menu")
    }
  }

  const Sticky = () => {
    if(window.scrollY > 50){
       document.getElementById('header-container').classList.add('fixed-top');
    }else{
      document.getElementById('header-container').classList.remove('fixed-top');
    }
  }

  useEffect(() => {
    setNavigationMenu("navigation-menu")
    window.addEventListener('scroll', Sticky)
  }, [location]);

  return (
    <header id="header-container">
       {/* Top Bar Start */}
        <div className="border-bottom">
            <Container className="py-2">
                <Row>
                    <Col sm={8}>
                      <div className="site-info d-flex align-items-center">
                        <i><FaMobileAlt /></i><span className='mt-1' >+8801621000361</span>
                        <span style={{paddingLeft: "5px"}}>||</span>
                        <i><FaEnvelope /></i><span>srmiltonhossain@gmail.com</span>
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="social-mini-button float-end">
                          <i><FaFacebook style={{cursor: "pointer"}} onClick={ () => openInNewTab("https://www.facebook.com/asrmiltonkhan")}/></i>
                          <i><FaYoutube style={{cursor: "pointer"}} onClick={ () => openInNewTab("https://www.youtube.com/@srmiltonkhan")}/></i>
                          <i><FaTwitter style={{cursor: "pointer"}} onClick={ () => openInNewTab("https://twitter.com/SRMILTONKHAN")}/></i>
                          <i><FaGithub style={{cursor: "pointer"}} onClick={ () => openInNewTab("https://github.com/srmiltonkhan")}/></i>
                      </div>
                    </Col>
                </Row>
            </Container>
        </div>
        {/* Top Bar End */}

        <Container fluid className='border-bottom'>
          <Container>
            <Row>
              <Col xl={4}>
                <div className="d-flex justify-content-between align-items-center" id='navbar-brand-container'>
                  <h1>MILTON HOSSAIN</h1>
                  <i><FaBars className="fs-2 border" onClick={handleToggleButton}/></i>
               </div>
              </Col>
              <Col xl={8}>
                <nav className={navigationMenu} id="navigationMenu">
                  <NavLink to="/" className={location.pathname === "/" ? "active-menu" : ""}>HOME</NavLink>
                  <NavLink to="about" className={location.pathname === "/about" ? "active-menu" : ""}>ABOUT</NavLink>              
                  <NavLink to="experience" className={location.pathname === "/experience" ? "active-menu" : ""}>EXPERIENCE</NavLink>              
                  <NavLink to="education" className={location.pathname === "/education" ? "active-menu" : ""}>EDUCATION</NavLink>   
                  <NavLink to="projects" className={location.pathname === "/projects" ? "active-menu" : ""}>PROJECTS</NavLink>                                    
                  <NavLink to="skills" className={location.pathname === "/skills" ? "active-menu" : ""}>SKILLS</NavLink>                                    
                  <NavLink to="publication" className={location.pathname === "/publication" ? "active-menu" : ""}>PUBLICATION</NavLink>   
                  <NavLink to="contact" className={location.pathname === "/contact" ? "active-menu" : ""}>CONTACT</NavLink>
                </nav>
              </Col>
            </Row>
          </Container>
         </Container>
    </header>
  )
}

export default Header